<img [ngClass]="{'image-payment':source==='payment-details'}" [src]="iconImage" [attr.alt]="title ? title.toLowerCase() : ''" />
<div *ngIf="title" class="title" [innerHtml]="title"></div>
<div *ngIf="subtitle" class="subtitle" [innerHtml]="subtitle"></div>
